import type { FetcherStatus } from '../../types';

const STATUS: Record<FetcherStatus['status'], { label: string; cls: string }> = {
  ready: {
    label: 'Ready',
    cls: 'bg-green-100 dark:bg-green-900/40 text-green-700 dark:text-green-300',
  },
  needs_setup: {
    label: 'Needs setup',
    cls: 'bg-gray-100 dark:bg-gray-700 text-gray-600 dark:text-gray-300',
  },
  unavailable: {
    label: 'Unavailable',
    cls: 'bg-red-100 dark:bg-red-900/40 text-red-700 dark:text-red-300',
  },
  off: {
    label: 'Off',
    cls: 'bg-gray-100 dark:bg-gray-700 text-gray-500 dark:text-gray-400',
  },
};

/** The status in words, for places too small for the badge. */
export const STATUS_WORDS: Record<FetcherStatus['status'], string> = Object.fromEntries(
  Object.entries(STATUS).map(([k, v]) => [k, v.label]),
) as Record<FetcherStatus['status'], string>;

/** A fetcher's status, decided server-side from facts (a host that's set, browsers that are connected). */
export function StatusBadge({ status }: { status: FetcherStatus['status'] }) {
  const s = STATUS[status] ?? STATUS.needs_setup;
  return (
    <span className={`px-1.5 py-0.5 text-[10px] font-medium rounded ${s.cls}`}>{s.label}</span>
  );
}

/** Something that serves EVERY user's fetches. Same amber pill as the "System" badge on LLM
 *  providers, with words that say what it means. */
export function SharedBadge({ since }: { since?: string | null }) {
  return (
    <span
      className="px-1.5 py-0.5 text-[10px] font-medium bg-amber-100 dark:bg-amber-900/40 text-amber-700 dark:text-amber-300 rounded"
      title={since ? `Shared since ${new Date(since).toLocaleString()}` : undefined}
    >
      Shared with all users
    </span>
  );
}
